import React from 'react';
import DialogueWrapper from "./DialogueWrapper"

const PreviewFileModal = ({ previewFile, toggleModalFn }) => {
    return <DialogueWrapper isPreview={true} maxWidth="lg" open={previewFile.modal} dialogueTitle="Preview" dialogueWidth="1200px" toggleModalFn={toggleModalFn}  >
        {previewFile?.singlePreview ? previewFile?.data?.map((file, index) => (
            <div key={index}>
                {
                    file?.type === 'application/pdf' ? (
                        <object type='text/html' data={URL.createObjectURL(file)} style={{ width: '100%', height: '100vh' }}>
                            <param name='type' value='text/html' />
                        </object>
                    ) : (file?.type?.startsWith('image/jpeg') ||file?.type?.startsWith('image/jpg') ||file?.type?.startsWith('image/png') ) ? 
                        <img src={URL.createObjectURL(file)} alt={file.name} style={{ width: '100%', height: '100vh' }} /> : <p style={{padding : "12px",display: "flex",justifyContent:"center"}}>Preview is not available for this File Type.</p>
                }
            </div>
        ))
            :
            previewFile?.data?.file_name?.endsWith('.xls') || previewFile?.data?.file_name?.endsWith('.xlsx') || previewFile?.data?.file_name?.endsWith('.docx') || previewFile?.data?.file_name?.endsWith('.doc') ?
                <div>
                    <iframe src={'https://view.officeapps.live.com/op/embed.aspx?src=' + encodeURIComponent(previewFile?.data?.file_url)} width='100%' height={window.innerHeight} frameborder='0'></iframe></div> : null
        }
    </DialogueWrapper>
}
export default PreviewFileModal